import React, {useState, useEffect} from "react";
import {useGlobalContext} from "../context/GlobalState";
import {Box, Typography, CircularProgress} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import {BarChartPro} from '@mui/x-charts-pro/BarChartPro';
import {axisClasses} from "@mui/x-charts";
import {ReviewStateEnum} from "../services/Utils";
import {useNavigate} from "react-router-dom";

function getReviewCount(dashData, reviewState) {
    const filteredData = dashData?.filter((review) => review.reviewStateId === reviewState);
    let count = 0;
    filteredData?.forEach(v => count += v.depositCount);
    return count;
}

export const CheckBarChart = () => {
    const {dashData, setTabStatus} = useGlobalContext();
    const [loading, setLoading] = useState(false)
    const theme = useTheme();
    const navigate = useNavigate();

    function handleAxisClick(event, data) {
        setTabStatus(data.axisValue);
        navigate("/deposit-review")
    }

    useEffect(() => {
        setLoading(!dashData)
    }, [dashData]);

    const data = {
        datasets: [
            {
                label: "Pending",
                data: getReviewCount(dashData, ReviewStateEnum.Pending),
            },
            {
                label: "Approved",
                data: getReviewCount(dashData, ReviewStateEnum.Approved),
            },
            {
                label: "Rejected",
                data: getReviewCount(dashData, ReviewStateEnum.Rejected),
            },
        ],
    };

    return (
        <Box
            sx={{
                position: "relative",
                background: theme.palette.primary.componentbg,
                borderRadius: 1,
                padding: 1,
                height: "100%",
                boxSizing: "border-box",
                boxShadow: "3"
            }}
        >
            <Typography variant="h5" style={{textAlign: "left"}}>
                Deposits by Review Status
            </Typography>
            <Box
                sx={{
                    height: "calc(100% - 32px)",
                    width: "100%",
                    boxSizing: "border-box",
                    position: "relative"
                }}
            >
                {loading && (
                    <Box
                        sx={{
                            position: "absolute",
                            inset: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "primary.componentbg",
                            opacity: 0.7,
                            zIndex: 1
                        }}
                    >
                        <CircularProgress/>
                    </Box>
                )}
                <BarChartPro
                    layout="horizontal"
                    margin={{left: 65}}
                    sx={{
                        [`.${axisClasses.root}`]: {
                            [`.${axisClasses.tick}, .${axisClasses.line}`]: {
                                stroke: theme.palette.gray.light,
                                strokeWidth: 2,
                            },
                            [`.${axisClasses.tickLabel}`]: {
                                fill: theme.palette.gray.graph,
                            },
                        },
                    }}
                    onAxisClick={(event, data) => handleAxisClick(event, data)}
                    dataset={data.datasets}
                    xAxis={[{
                        max: Math.max(...data.datasets.map((dataset) => dataset.data)) + 5 || 10,
                        tickMinStep: 1,
                    }]}
                    yAxis={[{
                        dataKey: 'label',
                        scaleType: 'band',
                        colorMap: {
                            type: 'ordinal',
                            colors: [theme.palette.primary.main, theme.palette.accent.success, theme.palette.accent.error],
                        }
                    }]}
                    series={[{
                        dataKey: 'data',
                        type: 'bar',
                    }]}
                />
            </Box>
        </Box>
    );
};